/**
 * Extrae un mensaje legible de un error de Axios/Laravel.
 * Prioriza el primer error de validación, luego `message`, y por último el fallback.
 */
export function errMsg(err: unknown, fallback = "Ha ocurrido un error."): string {
  const e = err as {
    response?: { data?: { message?: string; errors?: Record<string, string[]> } };
  };
  const firstValidation = e?.response?.data?.errors
    ? Object.values(e.response.data.errors).flat()[0]
    : null;
  return firstValidation ?? e?.response?.data?.message ?? fallback;
}
